import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(" Transfer some stock between warehouses, without customs clearance ")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.isLoading ? _c("div", {
    staticClass: "text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : [_c("div", {
    staticClass: "text-smaller"
  }, [_c("div", [_vm._v(_vm._s("".concat(_vm.quantityAvailable, " x ").concat(_vm.wineName)))]), _vm.fromWarehouseName ? _c("div", [_vm._v("from " + _vm._s(_vm.fromWarehouseName))]) : _vm._e()]), _c(VForm, {
    staticClass: "dfwa-form mt-default",
    model: {
      value: _vm.addingEntity.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "valid", $$v);
      },
      expression: "addingEntity.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      type: "number",
      label: "Quantity to transfer",
      placeholder: "Number of bottles",
      min: 1,
      max: _vm.quantityAvailable,
      rules: [_vm.formRules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingEntity.form.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "quantity", $$v);
      },
      expression: "addingEntity.form.quantity"
    }
  }), _c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      label: "Destination warehouse",
      items: _vm.gettingWarehouses.itemsForDestination,
      "item-value": "id_warehouse",
      "item-text": "name",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: function change($event) {
        return _vm.changeDestinationWarehouse();
      }
    },
    model: {
      value: _vm.addingEntity.form.toWarehouseId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "toWarehouseId", $$v);
      },
      expression: "addingEntity.form.toWarehouseId"
    }
  }), _c("div", {
    staticClass: "text-smaller"
  }, [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v(" The intended country and default reservation of the destination stock will come from the selected warehouse. ")])]), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.gettingPendingTransfers.items.length === 0,
      loading: _vm.gettingPendingTransfers.isPending,
      label: !_vm.addingEntity.form.toWarehouseId ? "Select the destination warehouse to sync pending transfers" : _vm.gettingPendingTransfers.isPending ? "Loading matching pending transfers..." : _vm.gettingPendingTransfers.items.length > 0 ? "Add to pending transfer" : "No pending transfer match this config",
      items: _vm.gettingPendingTransfers.items,
      "item-value": "id",
      "item-text": "displayName",
      placeholder: "Create a new transfer",
      "hide-details": "auto",
      clearable: "",
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: _vm.changePendingTransfer
    },
    model: {
      value: _vm.addingEntity.form.stockTransferDomesticId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "stockTransferDomesticId", $$v);
      },
      expression: "addingEntity.form.stockTransferDomesticId"
    }
  }), !_vm.addingEntity.form.stockTransferDomesticId ? _c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "New transfer reference",
      placeholder: "Transfer reference",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.reference,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "reference", $$v);
      },
      expression: "addingEntity.form.reference"
    }
  }) : _vm._e(), !_vm.addingEntity.form.stockTransferDomesticId ? _c(VTextarea, {
    attrs: {
      label: "Comment",
      placeholder: "Explain the reason of this transfer",
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "comment", $$v);
      },
      expression: "addingEntity.form.comment"
    }
  }) : _vm._e()], 1), _c(VAlert, {
    staticClass: "--small mt-default",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "red",
      text: ""
    }
  }, [_vm._v(" If the transfer is attached to an order that already existis on the platform, you must create them from the page of this order ")]), _c(VAlert, {
    staticClass: "--small mt-small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" Please ensure that there is no need to create a new invoice for this transfer, as doing so may cause accounting issues ")])], _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [!_vm.isLoading ? [!_vm.addingEntity.form.stockTransferDomesticId ? [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.addingEntity.form.valid || _vm.fromWarehouseId === _vm.addingEntity.form.toWarehouseId,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmNewImmediateTransfer();
      }
    }
  }, [_vm._v(" Immediate transfer ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.addingEntity.form.valid || _vm.fromWarehouseId === _vm.addingEntity.form.toWarehouseId,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmNewPendingTransfer();
      }
    }
  }, [_vm._v(" Initiate new pending transfer ")])] : _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.addingEntity.form.valid || _vm.fromWarehouseId === _vm.addingEntity.form.toWarehouseId,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.addPartToPendingTransfer();
      }
    }
  }, [_vm._v(" Add to pending transfer ")])] : _vm._e()], 2)], 2)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };